import { UserAttributes, UserSearchRequest, UserSearchResponse } from "../service";
import { BaseService } from "./baseService";
import { UserProfilePicturePresignURLRequest, UserProfilePicturePresignURLResponse, UserUpdateRequest } from "./types";

export class UserService extends BaseService {
    /**
     * Get current user's attributes
     */
    static async getCurrentUser(): Promise<UserAttributes | null> {
        try {
            const response = await this.get("/user");

            if (response.status === 404) {
                console.warn("User attributes not found (404)");
                return null;
            }

            return await this.handleResponse<UserAttributes>(response);
        } catch (error) {
            console.error("Error fetching user attributes:", error);
            throw error;
        }
    }

    /**
     * Update current user's attributes
     */
    static async updateCurrentUser(
        updates: UserUpdateRequest
    ): Promise<UserAttributes> {
        try {
            const response = await this.post("/user/update", updates);
            return await this.handleResponse<UserAttributes>(response);
        } catch (error) {
            console.error("Error updating user attributes:", error);
            throw error;
        }
    }

    static async searchUsers(request: UserSearchRequest): Promise<UserSearchResponse> {
        try {
            const response = await this.post("/user/search", {
                displayName: request.displayName || '',
                page: request.page || 1,
                limit: request.limit || 10
            });

            return await this.handleResponse<UserSearchResponse>(response);
        } catch (error) {
            console.error('Error searching users:', error);
            throw error;
        }
    }

    /**
     * Send profile picture metadata to get presigned url
     */
    static async getPresignedProfilePhotoURL(
        updates: UserProfilePicturePresignURLRequest
    ): Promise<UserProfilePicturePresignURLResponse> {
        try {
            const response = await this.post("/user/profilepicture", updates);
            return await this.handleResponse<UserProfilePicturePresignURLResponse>(response);
        } catch (error) {
            console.error("Error obtaining presign profile url:", error);
            throw error;
        }
    }

    /**
     * Suspend a user by their public handle
     */
    static async suspendUser(publicHandle: string): Promise<{ success: boolean; message: string }> {
        try {
            const response = await this.post("/user/suspend", { publicHandle });
            return await this.handleResponse<{ success: boolean; message: string }>(response);
        } catch (error) {
            console.error("Error suspending user:", error);
            throw error;
        }
    }

}